export default __webpack_public_path__ + "static/media/illustrationBg.f3b5ebb5.png";